
import ClientButton from '../../components/master/common/Clientbutton';
import ClientFooter from '../../components/master/common/ClientFooter';

export default {
  encodedKey: process.env.REACT_APP_HELLO_HEALTH_ENCODED_KEY_FOR_URL,
  ButtonComponent: ClientButton,
  FooterComponent: ClientFooter,
  buttonText: 'Take the Assessment',
  headerText: 'Your health is "Wirth" our time.',
  subText: "Take our assessment and harness cutting edge AI to recommend the perfect wellness routine for you.",
  timerText: 'It takes 2-3 minutes.',
  clientText: '**Pamela Wirth**, <br/> Founder and CEO  <br/> in collaboration with AI-MD'
};
